import { createStore } from 'vuex';

/* Plugins */
import vuexLocalStorage from './plugins/acvStorage';
import vuexUserStorage from './plugins/userStorage';
import featureFlagOverridesPlugin from './plugins/featureFlagOverrides';

/* Modules */
import auctions from './modules/auctions/auctions.module';
import acvApiConstants from './modules/acvApiConstants.module';
import announcements from './modules/announcements.module';
import arbitration from './modules/arbitration.module';
import authorization from './modules/authorization.module';
import bidding from './modules/bidding.module';
import dealershipAddress from './modules/dealershipAddress.module';
import devFlags from './modules/devFlags.module';
import devTools from './modules/dev-tools/devTools.module';
import featureFlags from './modules/featureFlags.module';
import featureFlagOverrides from './modules/featureFlagOverrides.module';
import filters from './modules/filters.module';
import messaging from './modules/messaging.module';
import myAcvInvoices from './modules/myAcvInvoices.module';
import myAcv from './modules/myAcv.module';
import myInventory from './modules/myInventory.module';
import network from './modules/network/network.module';
import notifications from './modules/notifications.module';
import offboarding from './modules/offboarding.module';
import offers from './modules/offers.module';
import tours from './modules/tours.module';
import uiSettings from './modules/uiSettings.module';
import mobileTopBar from './modules/mobileTopBar.module';
import marketplaceAuctions from './modules/marketplace-auctions/marketplace-auctions.module';
import marketplaceRouter from './modules/marketplace/marketplaceRouter.module';
import marketplaceView from './modules/marketplace/marketplaceView.module';
import capital from './modules/capital.module';
import capitalRouting from './modules/capitalRouting.module';
import auctionCommonModals from './modules/auctions/auctionCommonModals.module';
import firebase from './modules/firebase.module';
import termsOfService from './modules/termsOfService.module';
import analytics from './modules/analytics.module';
import rewards from './modules/rewards.module';
import auctionAccess from './modules/auctionAccess.module';
import registrationSession from './modules/registrationSession.module';
import registrationWizard from './modules/registrationWizard.module';
import pandaMfe from './modules/pandaMfe/pandaMfe.module';
import recommendationBadges from './modules/recommendationBadges.module';
import retailPrice from './modules/retailPrice.module';
import inventoryMfe from './modules/inventoryMfe/inventoryMfe.module';
import route from './modules/route.module';
import titleHub from './modules/titleHub.module';
/* Messaging */
import handleMessage from '../messaging/handleMessage';

const store = createStore({
  plugins: [
    vuexLocalStorage.plugin,
    vuexUserStorage.plugin,
    featureFlagOverridesPlugin.plugin, // places dev panel overrides on top
  ],
  modules: {
    acvApiConstants,
    announcements,
    arbitration,
    auctions,
    authorization,
    bidding,
    capital,
    capitalRouting,
    dealershipAddress,
    devFlags,
    devTools,
    featureFlags,
    featureFlagOverrides,
    filters,
    firebase,
    marketplaceAuctions,
    marketplaceRouter,
    marketplaceView,
    messaging,
    myAcv,
    myAcvInvoices,
    myInventory,
    network,
    notifications,
    offboarding,
    offers,
    tours,
    uiSettings,
    auctionCommonModals,
    termsOfService,
    mobileTopBar,
    analytics,
    rewards,
    auctionAccess,
    registrationSession,
    registrationWizard,
    pandaMfe,
    recommendationBadges,
    retailPrice,
    inventoryMfe,
    route,
    titleHub,
  },
});
handleMessage(store);

export default store;
